__turbopack_context__.v({
  "ListPreviewBlock": "a-mF3W_ListPreviewBlock",
  "ListPreviewBlock__ListItem": "a-mF3W_ListPreviewBlock__ListItem",
  "text-center": "a-mF3W_text-center",
  "text-left": "a-mF3W_text-left",
  "text-right": "a-mF3W_text-right",
});
